import instance from "./api";

export const fetchAllUsers = () =>
  instance.get("/dashboard/users").then((r) => r.data ?? []);

export const blockUser = (userId, isBlocked) =>
  instance.patch(
    `/dashboard/blocked-user?user-id=${userId}&is_blocked=${isBlocked}`
  );

export const updateUser = ({ id, data }) =>
  instance.patch(`/dashboard/update-user?id=${id}`, data);

export const fetchUserById = (id) =>
  instance.get(`/dashboard/profile-user?id=${id}`).then((r) => {
    return r.data?.user ?? {};
  });
